<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100 w-full">
    <div
      class="text-center"
      style="
        border-radius: 8px;
        background: var(--White, #fff);
        box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.16);
        padding: 24px 60px 40px 60px;
        margin: 30px;
      "
    >
      <div class="flex justify-center mb-4"><Exclamation :fill="mainColor"></Exclamation></div>
      <h2
        class="text-5xl font-bold mb-8"
        :style="{ color: mainColor }"
        data-test="error-code"
      >
        404
      </h2>
      <h2
        class="text-4xl font-bold mb-8"
        data-test="error-message"
      >
        So sorry about this
      </h2>
      <p
        class="text-lg mb-6 max-w-2xl"
        data-test="error-description"
      >
        <slot> An error occured while loading your page. Please try again or contact us for assistance. </slot>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Exclamation from '@/assets/Exclamation.vue';
import { useDonorStore } from '@/stores/DonorStore.js';

let donorStore = useDonorStore();
const mainColor = ref('#4b5563');

onMounted(async () => {
  await donorStore.checkForMainColor();
  mainColor.value = donorStore.mainColor || '#4b5563';
});
</script>
